export default __webpack_public_path__ + "static/media/syllIcon.2bd99a26.png";